export function getCurrencySymbol(currencyName = 'Soles'): string {
    const currency = currencyName.toLowerCase().trim();

    if (
        currency.includes('dólar') ||
        currency.includes('dolar') ||
        currency.includes('dollars')
    ) {
        return '$';
    }

    return 'S/';
}

export function cleanAmount(amount: number | string): number {
    if (typeof amount === 'number') return amount;

    return Number(
        String(amount)
            .replace('S/', '')
            .replace('$', '')
            .trim()
    );
}

export function formatAmountByCurrency(
    amount: number | string,
    currencyName = 'Soles',
    currencySymbol = getCurrencySymbol(currencyName)
): string {
    const formattedAmount = parseAmount(amount).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return `${currencySymbol} ${formattedAmount}`;
}

export function parseAmount(value: string | number | null | undefined): number {
    return Number(
        String(value ?? '')
            .replace(/,/g, '')
            .replace(/[^\d.]/g, '')
    ) || 0;
}
